import { render, staticRenderFns } from "./HomeBody.vue?vue&type=template&id=102f4b2c&scoped=true&"
import script from "./HomeBody.vue?vue&type=script&lang=js&"
export * from "./HomeBody.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/body.css?vue&type=style&index=0&id=102f4b2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102f4b2c",
  null
  
)

export default component.exports